import {
  Amazon,
  Depop,
  Ebay,
  Etsy,
  Facebook,
  Google,
  Instagram,
  Lazada,
  LinkedIn,
  Mercadolibre,
  Mercari,
  Pinterest,
  Poshmark,
  RatioLandscape,
  RatioPortrait,
  RatioSquare,
  Shopee,
  Shopify,
  TikTok,
  Twitter,
  Vinted,
  WhatsApp,
  YouTube,
} from 'blaze-ui/icons'
import { DesignAspectRatio } from 'types'
export const DEFAULT_DESIGN_SIZE = 1080

export type AspectRatioKey =
  | 'instagram-square-post'
  | 'instagram-story'
  | 'instagram-reel'
  | 'instagram-portrait-post'
  | 'instagram-landscape-post'
  | 'tik-tok-post'
  | 'tik-tok-thumbnail'
  | 'youtube-channel-art'
  | 'youtube-profile-picture'
  | 'facebook-cover'
  | 'facebook-story'
  | 'facebook-post'
  | 'facebook-portrait-post'
  | 'facebook-marketplace'
  | 'facebook-profile-picture'
  | 'linkedin-profile-picture'
  | 'linkedin-post'
  | 'linkedin-portrait-post'
  | 'linkedin-banner'
  | 'twitter-profile-picture'
  | 'twitter-cover-image'
  | 'whatsapp-sticker'
  | 'pinterest'
  | 'ebay'
  | 'poshmark'
  | 'depop'
  | 'mercari'
  | 'mercadolibre'
  | 'shopee'
  | 'lazada'
  | 'etsy'
  | 'vinted'
  | 'amazon'
  | 'shopify-square'
  | 'landscape-post'
  | 'portrait-post'
  | 'square-post'
  | 'twitter-post'
  | 'twitter-portrait-post'
  | 'youtube-short'
  | 'google-my-business-post'

export enum DesignChannel {
  InstagramPost = 'instagram_post',
  InstagramStory = 'instagram_story',
  InstagramReel = 'instagram_reel',
  TikTokPost = 'tiktok_post',
  TikTokThumbnail = 'tiktok_thumbnail',
  YoutubeProfilePicture = 'youtube_profile_picture',
  YoutubeChannelArt = 'youtube_channel_art',
  FacebookCover = 'facebook_cover',
  FacebookProfilePicture = 'facebook_profile_picture',
  FacebookPost = 'facebook_post',
  FacebookMarketplace = 'facebook_marketplace',
  LinkedInBanner = 'linkedin_banner',
  LinkedInProfilePicture = 'linkedin_profile_picture',
  LinkedInPost = 'linkedin_post',
  TwitterProfilePicture = 'twitter_profile_picture',
  TwitterCoverImage = 'twitter_cover_image',
  WhatsAppSticker = 'whatsapp_sticker',
  Pinterest = 'pinterest',
  Ebay = 'ebay',
  Poshmark = 'poshmark',
  Depop = 'depop',
  Mercari = 'mercari',
  MercadoLibre = 'mercadolibre',
  Shopee = 'shopee',
  Lazada = 'lazada',
  Etsy = 'etsy',
  Vinted = 'vinted',
  Amazon = 'amazon',
  Shopify = 'shopify',
  FacebookStory = 'facebook_story',
  TwitterPost = 'twitter_post',
  Post = 'post',
  YoutubeShort = 'youtube_short',
  GoogleMyBusinessPost = 'google_my_business_post',
  MetaAds = 'meta_ads',
}

/** Channels that represent ad creatives — not postable, not schedulable */
export const AD_DESIGN_CHANNELS: string[] = [DesignChannel.MetaAds, 'ad_campaign']

export enum DesignChannelMarketplace {
  FacebookMarketplace = DesignChannel.FacebookMarketplace,
  WhatsAppSticker = DesignChannel.WhatsAppSticker,
  LinkedInProfilePicture = DesignChannel.LinkedInProfilePicture,
  FacebookProfilePicture = DesignChannel.FacebookProfilePicture,
  YoutubeProfilePicture = DesignChannel.YoutubeProfilePicture,
  TwitterProfilePicture = DesignChannel.TwitterProfilePicture,
  Pinterest = DesignChannel.Pinterest,
  Ebay = DesignChannel.Ebay,
  Poshmark = DesignChannel.Poshmark,
  Depop = DesignChannel.Depop,
  Mercari = DesignChannel.Mercari,
  MercadoLibre = DesignChannel.MercadoLibre,
  Shopee = DesignChannel.Shopee,
  Lazada = DesignChannel.Lazada,
  Etsy = DesignChannel.Etsy,
  Vinted = DesignChannel.Vinted,
  Amazon = DesignChannel.Amazon,
  Shopify = DesignChannel.Shopify,
}

export const DesignChannels: Record<AspectRatioKey, DesignChannel> = {
  'instagram-square-post': DesignChannel.InstagramPost,
  'instagram-story': DesignChannel.InstagramStory,
  'instagram-reel': DesignChannel.InstagramReel,
  'instagram-portrait-post': DesignChannel.InstagramPost,
  'instagram-landscape-post': DesignChannel.InstagramPost,
  'tik-tok-post': DesignChannel.TikTokPost,
  'tik-tok-thumbnail': DesignChannel.TikTokThumbnail,
  'youtube-short': DesignChannel.YoutubeShort,
  'youtube-channel-art': DesignChannel.YoutubeChannelArt,
  'youtube-profile-picture': DesignChannel.YoutubeProfilePicture,
  'facebook-cover': DesignChannel.FacebookCover,
  'facebook-story': DesignChannel.FacebookStory,
  'facebook-post': DesignChannel.FacebookPost,
  'facebook-portrait-post': DesignChannel.FacebookPost,
  'facebook-profile-picture': DesignChannel.FacebookProfilePicture,
  'facebook-marketplace': DesignChannel.FacebookMarketplace,
  'linkedin-profile-picture': DesignChannel.LinkedInProfilePicture,
  'linkedin-post': DesignChannel.LinkedInPost,
  'linkedin-portrait-post': DesignChannel.LinkedInPost,
  'linkedin-banner': DesignChannel.LinkedInBanner,
  'twitter-profile-picture': DesignChannel.TwitterProfilePicture,
  'twitter-cover-image': DesignChannel.TwitterCoverImage,
  'whatsapp-sticker': DesignChannel.WhatsAppSticker,
  pinterest: DesignChannel.Pinterest,
  ebay: DesignChannel.Ebay,
  poshmark: DesignChannel.Poshmark,
  depop: DesignChannel.Depop,
  mercari: DesignChannel.Mercari,
  mercadolibre: DesignChannel.MercadoLibre,
  shopee: DesignChannel.Shopee,
  lazada: DesignChannel.Lazada,
  etsy: DesignChannel.Etsy,
  vinted: DesignChannel.Vinted,
  amazon: DesignChannel.Amazon,
  'shopify-square': DesignChannel.Shopify,
  'landscape-post': DesignChannel.Post,
  'portrait-post': DesignChannel.Post,
  'square-post': DesignChannel.Post,
  'twitter-post': DesignChannel.TwitterPost,
  'twitter-portrait-post': DesignChannel.TwitterPost,
  'google-my-business-post': DesignChannel.GoogleMyBusinessPost,
}

export type AspectRatioType = 'portrait' | 'square' | 'landscape'

// This is a reverse mapping of DesignChannels, but beware Post and InstagramPost
// do not have a direct mapping because they depend on aspect ratio
export const DesignChannelToAspectRatio: Record<DesignChannel, AspectRatioKey> = Object.entries(DesignChannels).reduce(
  (acc, [key, value]) => {
    acc[value] = key as AspectRatioKey
    return acc
  },
  {} as Record<DesignChannel, AspectRatioKey>,
)

export const getAspectRatioKeyFromDesignChannel = (
  channel: DesignChannel,
  width: number,
  height: number,
): AspectRatioKey => {
  if (channel === DesignChannel.Post) {
    if (width === height) {
      return 'square-post'
    } else if (width > height) {
      return 'landscape-post'
    } else {
      return 'portrait-post'
    }
  }

  if (channel === DesignChannel.InstagramPost) {
    if (width === height) {
      return 'instagram-square-post'
    } else if (width > height) {
      return 'instagram-landscape-post'
    } else {
      return 'instagram-portrait-post'
    }
  }

  if (channel === DesignChannel.FacebookPost) {
    if (height > width) {
      return 'facebook-portrait-post'
    } else {
      return 'facebook-post'
    }
  }

  return DesignChannelToAspectRatio[channel]
}

export const ASPECT_RATIOS: Record<AspectRatioKey, DesignAspectRatio> = {
  'instagram-square-post': {
    name: 'Instagram Square Post',
    width: 1080,
    height: 1080,
    icon: Instagram,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_IG_Square_bmwpvg.png',
  },
  'instagram-story': {
    name: 'Instagram Story',
    width: 1080,
    height: 1920,
    icon: Instagram,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_IG_Story_runivs.png',
  },
  'instagram-reel': {
    name: 'Instagram Reel',
    width: 1080,
    height: 1920,
    icon: Instagram,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_IG_Reel_vld2bp.png',
  },
  'instagram-portrait-post': {
    name: 'Instagram Portrait Post',
    width: 1080,
    height: 1350,
    icon: Instagram,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_IG_Portrait_pyef1n.png',
  },
  'instagram-landscape-post': {
    name: 'Instagram Horizontal Post',
    width: 1200,
    height: 630,
    icon: Instagram,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_IG_Landscape_yi6pwi.png',
  },
  'tik-tok-post': {
    name: 'TikTok Post',
    width: 1080,
    height: 1920,
    icon: TikTok,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_Tiktok_Video_du9mun.png',
  },
  'tik-tok-thumbnail': {
    name: 'TikTok Thumbnail',
    width: 1080,
    height: 1920,
    icon: TikTok,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_Tiktok_Thumb_anboju.png',
  },
  'youtube-short': {
    name: 'YouTube Short',
    width: 1080,
    height: 1920,
    icon: YouTube,
    image:
      'https://res.cloudinary.com/almanac/image/upload/v1742504127/blaze_assets/create_new_v3/Type_YT_Profile_cc2fhk.png',
  },
  'youtube-channel-art': {
    name: 'YouTube Channel Art',
    width: 1280,
    height: 720,
    icon: YouTube,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_YT_Cover_ruk8pe.png',
  },
  'youtube-profile-picture': {
    name: 'YouTube Profile Picture',
    width: 512,
    height: 512,
    icon: YouTube,
    image:
      'https://res.cloudinary.com/almanac/image/upload/v1742504127/blaze_assets/create_new_v3/Type_YT_Profile_cc2fhk.png',
  },
  'twitter-profile-picture': {
    name: 'X/Twitter Profile Picture',
    width: 512,
    height: 512,
    icon: Twitter,
    image:
      'https://res.cloudinary.com/almanac/image/upload/v1742504126/blaze_assets/create_new_v3/Type_X_Profile_Picture_uhfcn8.png',
  },
  'twitter-cover-image': {
    name: 'X/Twitter Cover Image',
    width: 820,
    height: 312,
    icon: Twitter,
    image:
      'https://res.cloudinary.com/almanac/image/upload/v1742504125/blaze_assets/create_new_v3/Type_x_Banner_vrfe8y.png',
  },
  'facebook-story': {
    name: 'Facebook Story',
    width: 1080,
    height: 1920,
    icon: Facebook,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_FB_Visual_jfjpb4.png',
  },
  'facebook-cover': {
    name: 'Facebook Cover',
    width: 820,
    height: 312,
    icon: Facebook,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_FB_Banner_dad4ti.png',
  },
  'facebook-post': {
    name: 'Facebook Visual Post',
    width: 1200,
    height: 630,
    icon: Facebook,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_FB_Visual_jfjpb4.png',
  },
  'facebook-portrait-post': {
    name: 'Facebook Portrait Post',
    width: 1080,
    height: 1350,
    icon: Facebook,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_FB_Visual_jfjpb4.png',
  },
  'facebook-marketplace': {
    name: 'Facebook Marketplace',
    width: 1600,
    height: 1600,
    icon: Facebook,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_Facebook_zkg5am.png',
  },
  'facebook-profile-picture': {
    name: 'Facebook Profile Picture',
    width: 512,
    height: 512,
    icon: Facebook,
    image:
      'https://res.cloudinary.com/almanac/image/upload/v1742504375/blaze_assets/create_new_v3/Type_FB_Profile_borru0.png',
  },
  'linkedin-profile-picture': {
    name: 'LinkedIn Profile Picture',
    width: 512,
    height: 512,
    icon: LinkedIn,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_LI_Picture_m2yirv.png',
  },
  'linkedin-post': {
    name: 'LinkedIn Visual Post',
    width: 1200,
    height: 630,
    icon: LinkedIn,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_LI_Visual_e9dxo7.png',
  },
  'linkedin-portrait-post': {
    name: 'LinkedIn Portrait Post',
    width: 1080,
    height: 1350,
    icon: LinkedIn,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_LI_Visual_e9dxo7.png',
  },
  'linkedin-banner': {
    name: 'LinkedIn Banner',
    width: 820,
    height: 312,
    icon: LinkedIn,
    image:
      'https://res.cloudinary.com/almanac/image/upload/v1734726154/blaze_assets/create_new_v3/Type_LI_Profile_Banner_igao1j.png',
  },
  'whatsapp-sticker': {
    name: 'WhatsApp Sticker',
    width: 512,
    height: 512,
    icon: WhatsApp,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_WA_Sticker_aru93p.png',
  },
  pinterest: {
    name: 'Pinterest Post',
    width: 735,
    height: 1102,
    icon: Pinterest,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_Pinterest_aaesrr.png',
  },
  ebay: {
    name: 'eBay Product Visuals',
    width: 1600,
    height: 1600,
    icon: Ebay,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Marketplace-Ebay_kyqpyg.png',
  },
  poshmark: {
    name: 'Poshmark Product Visuals',
    width: 1600,
    height: 1600,
    icon: Poshmark,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Marketplace-Poshmark_h1ut1j.png',
  },
  depop: {
    name: 'Depop Product Visuals',
    width: 1600,
    height: 1600,
    icon: Depop,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Marketplace-Depop_xof4mw.png',
  },
  mercari: {
    name: 'Mercari Product Visuals',
    width: 1600,
    height: 1600,
    icon: Mercari,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Marketplace-Mercari_an4de4.png',
  },
  mercadolibre: {
    name: 'MercadoLibre Product Visuals',
    width: 1600,
    height: 1600,
    icon: Mercadolibre,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Marketplace-Mercado_o7gxxt.png',
  },
  shopee: {
    name: 'Shopee Product Visuals',
    width: 1600,
    height: 1600,
    icon: Shopee,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Marketplace-Shopee_fxpkaj.png',
  },
  lazada: {
    name: 'Lazada Product Visuals',
    width: 1600,
    height: 1600,
    icon: Lazada,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Marketplace-Lazada_g5dlux.png',
  },
  etsy: {
    name: 'Etsy Product Visuals',
    width: 1600,
    height: 1600,
    icon: Etsy,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Marketplace-Etsy_suz8ru.png',
  },
  vinted: {
    name: 'Vinted Product Visuals',
    width: 800,
    height: 600,
    icon: Vinted,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Marketplace-Vinted_saixi8.png',
  },
  amazon: {
    name: 'Amazon Product Visuals',
    width: 1600,
    height: 1600,
    icon: Amazon,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Marketplace-Amazon_hj7wpa.png',
  },
  'shopify-square': {
    name: 'Shopify Square Item',
    width: 1600,
    height: 1600,
    icon: Shopify,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Marketplace-ShopifySquare_fm0xdh.png',
  },
  'landscape-post': {
    name: 'Landscape Visual Post',
    width: 1200,
    height: 630,
    icon: RatioLandscape,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Property_1_landspace_ctkxvs.png',
  },
  'portrait-post': {
    name: 'Portrait Visual Post',
    width: 1080,
    height: 1350,
    icon: RatioPortrait,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Property_1_portrait_s8p4yn.png',
  },
  'square-post': {
    name: 'Square Visual Post',
    width: 1080,
    height: 1080,
    icon: RatioSquare,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Property_1_square_cah2si.png',
  },
  'twitter-post': {
    name: 'X/Twitter Visual Post',
    width: 1200,
    height: 630,
    icon: Twitter,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_X_Visual_plt4nx.png',
  },
  'twitter-portrait-post': {
    name: 'X/Twitter Portrait Post',
    width: 1080,
    height: 1350,
    icon: Twitter,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_X_Visual_plt4nx.png',
  },
  'google-my-business-post': {
    name: 'Google My Business Post',
    width: 1200,
    height: 900,
    icon: Google,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Property_1_landspace_ctkxvs.png',
  },
}
